import { Pedido } from "./pedido";
import { Producto } from "./producto";

export class Lista {
    id: number;
    nombre: string;
    codigo: string;
    user: any;
    fecha: Date;
    lugar: string;
    // userMercadoPago: string;
    productos: Array<Producto>;
    pedidos: Array<Pedido>;
    // monetizada: boolean;
    activa: boolean;
    vigente: boolean;
    mail: boolean;
}